// const data = { refno: "12/T", title: "My Event", file: fileDOM }
//
// AppLoad(
//     AppConfig.APIUrl + 'admin/event-management/save',
//     data,
//     (event: any) => updatePercentage(event)
// ).then((Response: ISubmitResponse) => {
//     if (Response.status == 'error') {
//         setSubmitErrors(Response.errors)
//     } else if (Response.status == 'ok') {
//         setLoadState('saved');
//     }
// });
//
//
export function AppLoad(url, data = null, progressUpdate = null) {
    return new Promise(function (resolve, reject) {
        var xhttp = new XMLHttpRequest();
        xhttp.withCredentials = true; //to send auth cookie
        var form_data = new FormData();
        for (var key in data) {
            form_data.append(key, data[key]);
        }
        xhttp.onreadystatechange = function () {
            if (this.readyState == 4 && this.status == 200)
                resolve(JSON.parse(this.responseText));
        };
        if (progressUpdate)
            xhttp.addEventListener("progress", progressUpdate, false);
        if (progressUpdate)
            xhttp.upload.addEventListener("progress", progressUpdate, false);
        xhttp.open("POST", url, true);
        xhttp.send(form_data);
    });
}
